import { IoCContainer, IWebCoreSettings, WebCoreIoCKeys } from '@lmnop/web-core';
import { IAngularCoreIoCContainer } from 'angular-core-src';
import { CoreModulesIoC } from './core-modules-ioc.class';

export class AngularCoreIoCContainer implements IAngularCoreIoCContainer {
    public lateBindIoC(): void {
        this.core = new CoreModulesIoC();
        this.settings = IoCContainer.get(WebCoreIoCKeys.IWebCoreSettings);
    }

    public core: CoreModulesIoC;
    public settings: IWebCoreSettings;
}
